export const SET_USER = "SET_USER";
export const TOGGLE_SIDE_NAV = "TOGGLE_SIDE_NAV";
export const OPEN_POPUP = "OPEN_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";
export const SET_PERMISSION = "SET_PERMISSION";

export const SET_RUNNING_IMPORTS = "SET_RUNNING_IMPORTS";
export const COMPLETE_RUNNING_IMPORTS = "COMPLETE_RUNNING_IMPORTS";
export const CLEAR_RUNNING_IMPORTS = "CLEAR_RUNNING_IMPORTS";
export const SHOW_MAPPING = "SHOW_MAPPING";
export const HIDE_MAPPING = "HIDE_MAPPING";

export const SET_ENT_FETCHING = "SET_ENT_FETCHING";
export const SET_DS_FETCHING = "SET_DS_FETCHING";

export const ADD_DATA_SOURCES = "ADD_DATA_SOURCES";
export const CLEAR_DATA_SOURCES = "CLEAR_DATA_SOURCES";

export const ADD_ENTITIES = "ADD_ENTITIES";
export const CLEAR_ENTITIES = "CLEAR_ENTITIES";

export const SET_NOTIFICATIONS = "SET_NOTIFICAITONS";
export const SYNC_NOTIFICATIONS = "SYNC_NOTIFICAITONS";

export const SET_CONFIG = "SET_CONFIG";

export const SET_PROCESSQUEUE = "SET_PROCESSQUEUE";
export const SYNC_PROCESSQUEUE = "SYNC_PROCESSQUEUE";
export const SET_LOADINGFLAG = "SET_LOADINGFLAG";

export const HANDLE_EDIT_JOB = "HANDLE_EDIT_JOB";
export const HANDLE_PIPELINE_LIST = "HANDLE_PIPELINE_LIST";
export const SET_JOB_DETAILS = "SET_JOB_DETAILS";
export const OPEN_CONFIRM = "OPEN_CONFIRM";
export const CLOSE_CONFIRM = "CLOSE_CONFIRM";
export const OPEN_STOP_CONFIRM = "OPEN_STOP_CONFIRM";
export const CLOSE_STOP_CONFIRM = "CLOSE_STOP_CONFIRM";
export const OPEN_CONFLICT_CONFIRM = "OPEN_CONFLICT_CONFIRM";
export const CLOSE_CONFLICT_CONFIRM = "CLOSE_CONFLICT_CONFIRM";

export const SET_WORKSPACE = "SET_WORKSPACE";
export const UPDATE_CONFIGSTATUS = "UPDATE_CONFIGSTATUS";

export const SET_CLUSTER_LIST = "SET_CLUSTER_LIST";

export const SHOW_HELP = "SHOW_HELP";
export const HIDE_HELP = "HIDE_HELP";

export const SET_MANAGE_CASES = "SET_MANAGE_CASES";
export const SET_ENTITY_LOOKUP = "SET_ENTITY_LOOKUP";
export const SET_CUSTOM_SEARCH = "SET_CUSTOM_SEARCH";
